import gql from 'graphql-tag';

const SetUserDailyTimeEntryExpectedMutation = gql`
  mutation SetUserDailyTimeEntryExpected($input: UserDailyTimeEntryToggleExpectedInput!) {
    user_daily_time_entry_toggle_expected(input: $input) {
      id
      requires_time_entry
      can_set_expects_time_entry
    }
  }
`;

const setDailyTimeEntryStatusApi = async (client, paramUserId, paramDate) => {
  const variables = {
    input: {
      user_id: paramUserId,
      date: paramDate,
    },
  };

  const options = {
    mutation: SetUserDailyTimeEntryExpectedMutation,
    variables,
  };

  return client.mutate(options);
};


export default setDailyTimeEntryStatusApi;
